var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-h6 mx-3 my-2"
  }, [_vm._v(_vm._s(_vm.$t('QuickJump.QuickJump')))]), !(_vm.$s.QuickJump_ShowChangedWeapons || _vm.$s.QuickJump_ShowEvent) ? _c('span', [_c('v-divider'), _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('No Item : Check Config'))
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.$s.QuickJump_ShowEvent ? _c('span', [_c('v-divider'), _c('div', {
    staticClass: "text-subtitle-1 mx-5 my-2"
  }, [_vm._v(_vm._s(_vm.$t('Quest')))]), _vm.quests.length > 0 || _vm._challengeQuest != undefined ? _c('span', [_vm._l(_vm.quests, function (id) {
    return _c('span', [_c('v-divider'), _c('Quest', {
      key: "home-quest-".concat(id),
      attrs: {
        "id": id
      }
    })], 1);
  }), _vm._challengeQuest != undefined ? _c('span', [_c('v-divider'), _c('ChallengeQuest', {
    attrs: {
      "id": _vm._challengeQuest
    }
  })], 1) : _vm._e()], 2) : _c('span', [_c('NoItem')], 1)], 1) : _vm._e(), _vm.$s.QuickJump_ShowChangedWeapons ? _c('span', [_c('v-divider'), _c('div', {
    staticClass: "text-subtitle-1 mx-5 my-2"
  }, [_vm._v(_vm._s(_vm.$t('Weapon')))]), _vm.loading ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-divider'), _c('v-progress-circular', {
    staticClass: "my-4",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _c('span', [_vm.weapons.length > 0 ? _c('span', _vm._l(_vm.weapons, function (id) {
    return _c('span', [_c('v-divider'), _c('Weapon', {
      key: "home-weapon-".concat(id),
      attrs: {
        "id": id
      }
    })], 1);
  }), 0) : _c('span', [_c('NoItem')], 1)])], 1) : _vm._e(), _c('div', {
    staticClass: "mb-10"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }